import React from 'react';
import { Title, Meta, Link } from 'react-head';

const SEO = ({ title, description, href }) => {
  const domain = 'https://mahanc.com';
  const fullUrl = `${domain}${href}`;

  return (
    <>
      <Title>{title} | Mahanc</Title>

      <Meta name="description" content={description} />
      <Link rel="canonical" href={fullUrl} />

      <Meta property="og:type" content="website" />
      <Meta property="og:url" content={fullUrl} />
      <Meta property="og:title" content={title} />
      <Meta property="og:description" content={description} />
      <Meta property="og:image" content={`${domain}/img/logo-mahance.png`} />

      <Meta name="twitter:card" content="summary" />
      <Meta name="twitter:title" content={title} />
      <Meta name="twitter:description" content={description} />
    </>
  );
};

export default SEO;
